<template>
    <dv-border-box-12 class="total-container">
        <div class="item-bg">
            <div class="total-title">产废企业</div>
            <div class="total-num" style="color: #eeb1fd;">
                {{ totalInfo.totalManufacturer }}
            </div>
            <div class="total-compare"></div>
        </div>
        <div class="item-bg" style="cursor: pointer;" @click="showHwTypeList">
            <div class="total-title">危废种类</div>
            <div class="total-num" style="color: #24c9ff;">
                {{ totalInfo.totalHw }}
            </div>
            <div class="total-compare"></div>
        </div>
        <div class="item-bg">
            <div class="total-title">产废量({{totalInfo.unit}})</div>
            <div class="total-num" style="color: #00ff00;">
                {{ totalInfo.totalStorage }}
            </div>
            <div class="total-compare">
                <div v-if="totalInfo.storageGrowthRatio !== 0">
                    <span>环比</span>
                    <img v-if="totalInfo.storageGrowthRatio > 0" src="../../assets/image/icon-up.png" height="16" />
                    <img v-if="totalInfo.storageGrowthRatio < 0" src="../../assets/image/icon-down.png" height="16" />
                    <span>{{ totalInfo.storageGrowthRatio }}%</span>
                </div>
                <div v-else></div>
            </div>
        </div>
        <div class="item-bg">
            <div class="total-title">转运量({{totalInfo.unit}})</div>
            <div class="total-num" style="color: #11e2dd;">
                {{ totalInfo.totalTransfer }}
            </div>
            <div class="total-compare">
                <div v-if="totalInfo.transferGrowthRatio !== 0">
                    <span>环比</span>
                    <div v-if="totalInfo.transferGrowthRatio > 0">
                        <img src="../../assets/image/icon-up.png" height="16" />
                    </div>
                    <div v-else>
                        <img src="../../assets/image/icon-down.png" height="16" />
                    </div>
                    <span>{{ totalInfo.transferGrowthRatio }}%</span>
                </div>
                <div v-else></div>
            </div>
        </div>
        <div class="item-bg">
            <div class="total-title">暂存量({{totalInfo.unit}})</div>
            <div class="total-num" style="color: #ffff00;">
                {{ totalInfo.totalInventory }}
            </div>
            <div class="total-compare"></div>
        </div>
        <vodal :show="isShowDialog" :width="1200" :height="600" :duration="300" :closeOnClickMask="false" animation="zoom" @hide="isShowDialog = false">
            <Hw-Type-List />
        </vodal>
    </dv-border-box-12>
</template>

<script>
/* eslint-disable */
import EventBus from "../js/event-bus.js";
import Vodal from "../dialog/Vodal";
import HwTypeList from "../dialog/HwTypeList.vue";

export default {
    name: "HomePageTotal",
    components: {
        Vodal,
        HwTypeList,
    },
    data() {
        return {
            totalInfo: {},
            isShowDialog: false,
        };
    },
    mounted() {
        this.getHomePageTotal();
        EventBus.$on("inventoryChangedEvent", (row) => {
            this.getHomePageTotal();
        });
    },
    methods: {
        getHomePageTotal() {
            this.$api
                .getApplicationTotal()
                .then((result) => {
                    if (result.ok === true) {
                        this.totalInfo = result.data;
                    } else {
                        console.log("请求失败!");
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        showHwTypeList() {
            console.log("111");
            this.isShowDialog = true;
        },
    },
};
</script>

<style lang="less">
.total-container {
    .border-box-content {
        padding: 20px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        flex-direction: row;
    }

    .item-bg {
        width: 19%;
        height: 100%;
        background-color: rgba(1, 202, 217, 0.2);
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .total-title {
            font-size: 12px;
            text-align: center;
            height: 25%;
        }

        .total-num {
            font-size: 22px;
            text-align: center;
            height: 25%;
        }

        .total-compare {
            font-size: 12px;
            text-align: center;
            color: #789ce0;
            height: 10%;

            img {
                vertical-align: middle;
                margin: 0 3px;
            }
        }
    }
}
</style>
